import { render, staticRenderFns } from "./AssetLibrary.vue?vue&type=template&id=3f27fda9"
import script from "./AssetLibrary.vue?vue&type=script&lang=js"
export * from "./AssetLibrary.vue?vue&type=script&lang=js"
import style0 from "./AssetLibrary.vue?vue&type=style&index=0&id=3f27fda9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports